import classnames from 'classnames';
import * as R from 'ramda';
import React from 'react';
import {Motion, spring} from 'react-motion';

import {Button} from 'iss/widgets/Buttons';
import GlyphIcon from 'iss/widgets/bootstrap/GlyphIcon';

export class CollapsibleButtonPanel extends React.Component {
  static defaultProps = {
    initiallyOpen: false,
  };
  state = {
    opened: this.props.initiallyOpen,
  };
  render() {
    const {id, buttonText, children} = this.props;
    return <React.Fragment>
      <Button id={id+"-toggle"} buttonLook="link" onClick={this.toggleOpen}>
        {buttonText}
        {" "}
        <GlyphIcon icon={this.state.opened ? "chevron-down" : "chevron-right"} />
      </Button>
      <Collapse id={id} isOpened={this.state.opened}>
        {children}
      </Collapse>
    </React.Fragment>;
  }

  toggleOpen = () => {
    this.setState(R.evolve({opened: (opened) => !opened}));
  };
}

export function CollapsiblePanel({children, title, isOpened, onTitleClick, ...props}) {
  const openClass = isOpened ? "panel-open" : "panel-closed";
  return <PanelContainer className={openClass} {...props}>
    <div className="panel-heading" role="tab" onClick={onTitleClick}>
      <h4 className="panel-title">{title}</h4>
    </div>
    <Collapse isOpened={isOpened}>
      <div className="panel-body">{children}</div>
    </Collapse>
  </PanelContainer>;
}

export function Panel({children, title, onTitleClick, ...props}) {
  return <PanelContainer {...props}>
    {title && <div className="panel-heading" role="tab" onClick={onTitleClick}>
      <h4 className="panel-title">{title}</h4>
    </div>}
    <div className="panel-body">{children}</div>
  </PanelContainer>;
}

function PanelContainer({className, panelType, children, ...props}) {
  const typeClass = "panel-"+R.defaultTo('default', panelType);
  return <div className={classnames("panel", typeClass, className)} {...props}>
    {children}
  </div>;
}

class Collapse extends React.Component {
  state = {
    animating: false,
    targetHeight: 0
  };
  componentWillReceiveProps(nextProps) {
    if (nextProps.isOpened != this.props.isOpened) {
      this.setAnimating(true);
    }
  }
  componentDidMount() {
    this.setTargetHeight();
  }
  componentDidUpdate() {
    this.setTargetHeight();
  }
  setTargetHeight = () => {
    const targetHeight = this.props.isOpened ? this.content.clientHeight : 0;
    if (this.state.targetHeight != targetHeight) {
      this.setState({targetHeight});
    }
  };
  setAnimating = (animating) => {
    this.setState({animating});
  };
  render() {
    return <Motion onRest={() => this.setAnimating(false)}
           style={{height: spring(this.state.targetHeight, {precision: 1})}} >
      {({height}) => <div data-animating={this.state.animating} style={this.getStyle(height)}>
        <div id={this.props.id} ref={(elem) => this.content = elem}>{this.props.children}</div>
      </div>}
    </Motion>;
  }
  getStyle = (height) => {
    if (this.state.animating) {
      return {height, overflow: 'hidden'};
    }
    if (this.props.isOpened) {
      return {};
    }
    return {height: 0, overflow: 'hidden'};
  };
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/Panels.jsx